import { createComponent } from '@mpxjs/core';
import rnMixin from './rn-mixin';
createComponent({
    mixins: [rnMixin]
});
